module.exports = __webpack_public_path__ + "img/shop_pc_tab_02.71a9c50a.png";